
import React, { useEffect, useRef, useState } from "react";
import { Truck } from "lucide-react";
export default function FreeDeliveryBar({
  messages = ["Free Shipping on Orders above ₹499/-", "Anti-tarnish • Hypoallergenic • Stainless steel"," Minimum order ₹200/- only"],
  interval = 3000
}) {
  const [current, setCurrent] = useState(0);
  const [next, setNext] = useState(null); // null or index
  const [direction, setDirection] = useState(1); // 1 for next, -1 for prev
  const timerRef = useRef();
  const activeMessage =
  next !== null ? messages[next] : messages[current];

  useEffect(() => {
    if (messages.length <= 1) return;
    timerRef.current = setInterval(() => {
      handleNext(true);
    }, interval);
    return () => clearInterval(timerRef.current);
    // eslint-disable-next-line
  }, [messages, interval]);

  const handlePrev = (auto = false) => {
    if (next !== null) return;
    setDirection(-1);
    setNext((current - 1 + messages.length) % messages.length);
    if (!auto) resetTimer();
  };
  const handleNext = (auto = false) => {
    if (next !== null) return;
    setDirection(1);
    setNext((current + 1) % messages.length);
    if (!auto) resetTimer();
  };
  const resetTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = setInterval(() => {
        handleNext(true);
      }, interval);
    }
  };

  // After animation, update current
  useEffect(() => {
    if (next === null) return;
    const timeout = setTimeout(() => {
      setCurrent(next);
      setNext(null);
    }, 400);
    return () => clearTimeout(timeout);
  }, [next]);

  return (
    <div style={styles.wrapper}>
      <div style={styles.bar}>
        
        {/* Message Animation */}
        <div style={{ position: "relative", flex: 1, display: "flex", alignItems: "center", justifyContent: "center", minHeight: "32px", minWidth: 0, overflow: "hidden" }}>
          {/* Current message */}
          <span
            style={{
              ...styles.text,
              position: "absolute",
              left: "50%",
              top: "50%",
              transform:
                next === null
                  ? "translate3d(-50%, -50%, 0)"
                  : `translate3d(${direction === 1 ? '-150%' : '150%'}, -50%, 0)`,
              opacity: next === null ? 1 : 0,
              transition: "transform 0.4s cubic-bezier(.77,0,.18,1), opacity 0.3s",
              whiteSpace: "nowrap",
              willChange: "transform"
            }}
          >
            
            {messages[current] || ""}
          </span>
          {/* Incoming message */}
          {next !== null && (
            <span
              style={{
                ...styles.text,
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: `translate3d(${direction === 1 ? '150%' : '-150%'}, -50%, 0)`,
                opacity: 1,
                transition: "transform 0.4s cubic-bezier(.77,0,.18,1), opacity 0.3s",
                whiteSpace: "nowrap",
                willChange: "transform"
              }}
            >
              {messages[next] || ""}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "36px",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",

    zIndex: 1000,

    background: "linear-gradient(90deg, #C21833 0%, #E63946 50%, #C9A14A 100%)",

    boxShadow: "0 3px 10px rgba(194,24,51,0.15)",

    borderTop: "1px solid rgba(255,255,255,0.25)"  // 👈 MAGIC LINE
  },
  bar: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    padding: "0 12px",
    // gap: "8px"  
  },
  icon: {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  opacity: 0.95
},

  text: {
    fontSize: "13px",
    fontWeight: "500",
    color: "#fff",
    letterSpacing: "0.4px",
    opacity: 0.95,
    lineHeight: "1"   // 🔥 prevents vertical misalignment
  },
  arrowBtn: {
    background: "#fff",
    border: "1.5px solid #C9A14A",
    borderRadius: "50%",
    width: "34px",
    height: "34px",
    cursor: "pointer",
    fontSize: "20px",
    color: "#C9A14A",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 2px 8px rgba(201,161,74,0.10)",
    transition: "background 0.2s, border 0.2s, box-shadow 0.2s"
  },
  leftArrow: {
    marginRight: "16px"
  },
  rightArrow: {
    marginLeft: "16px"
  },
};